module.exports = __webpack_public_path__ + "74dc198109805b3496b42f1675805a1f.pdf";